import * as React from 'react'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'

interface Props {
  type?: 'error' | 'warning'
  message?: string
}

/**
 * エラー情報
 */
export const ErrorInformation: React.FC<Props> = (props) => {
  const { message } = props
  const type = props.type ? props.type : 'error'

  if (!message) { return <></> }

  return (
    <Box sx={{my:4}}>
      <Alert severity={type}>{message}</Alert>
    </Box>
  )
}

export default ErrorInformation
